import React from "react";
import { format, parseISO } from "date-fns";
import { useAuth } from "../../../context/API_Client";
import HoverToDisplayFullTitle from "../../../reusableComponents/HoverToDisplayFullTitle";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import { Typography } from "@mui/material";
import MoreOptionsPopOver from "../../../reusableComponents/moreOptionsPopOver/MoreOptionsPopOver";
import { Link } from "react-router-dom";

export default function NoOrLowCostEmiSchema(
  handleEditOffer,
  handleDeleteOffer,
  handleEnableOffer,
  handleDisableOffer
) {
  const { isAuthorizedPermission } = useAuth();
  const addSpacesBeforeCaps = (str) => {
    if (!str) return "";
    return str.replace(/([A-Z])/g, " $1").trim();
  };

  const copyFunction = ({ value }) => {
    const handleCopy = () => {
      navigator.clipboard.writeText(value);
      customToast("success", "medium", `Copied`);
    };

    return (
      <div
        style={{
          display: "flex",
          marginLeft: "-12px",
          alignItems: "center",
          minWidth: "100px",
          paddingRight: "30px",
        }}
      >
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1,
          }}
        >
          {value && <HoverToDisplayFullTitle title={value} len={12} />}
        </div>
        <img
          src="/assets/fileCopy.svg"
          alt="Copy"
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "0",
            marginRight: "16px",
          }}
          onClick={handleCopy}
        />
      </div>
    );
  };

  const handleActionSelect = (data) => {
    if (data?.type === "edit") {
      handleEditOffer(data);
    }
    if (data?.type === "delete") {
      handleDeleteOffer(data);
    }
    if (data?.type === "disable") {
      handleDisableOffer(data);
    }
    if (data?.type === "enable") {
      handleEnableOffer(data);
    }
  };

  const schema = {
    metadata: {
      title: "All Offers",
      minHeight: 600,
      position: "relative",
      rowHeight: 60,
      showTitle: false,
    },
    fields: [
      // {
      //   name: "code",
      //   header: "Offer Code",
      //   visible: true,
      //   type: "string",
      //   filtering: true,
      //   minWidth: 240,
      //   defaultFlex: 1,
      //   textAlign: "start",
      //   sortable: false,
      //   render: ({ data }) => (
      //     <span style={{ display: "flex", marginLeft: "-12px" }}>
      //       {data.code}
      //     </span>
      //   ),
      // },
      {
        name: "offerTitle",
        header: "Offer Title",
        visible: true,
        type: "string",
        filtering: true,
        minWidth: 240,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => (
          <span style={{
            marginLeft: "-12px",
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            flex: '1 1 0%'
          }}
            title={data.title}
          >
            {data.title}
          </span>
        ),
      },
      {
        name: "brand",
        header: "EMI Option",
        visible: true,
        type: "string",
        filtering: true,
        minWidth: 170,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => {
          const brand = data?.criteria?.applicableTo?.paymentMethods?.[0]?.brand;
          const formatBrand = (text) => {
            return text?.replace(/([a-z])([A-Z])/g, '$1 $2'); // Add a space before capital letters
          };
          const formattedDiscountType = formatBrand(brand);

          return (
            <span style={{ display: "flex", marginLeft: "-12px" }}>
              {formattedDiscountType}
            </span>
          );
        },
      },
      {
        name: "startDate",
        header: "Offer Validity",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 250,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => {
          const formatDate = data?.criteria?.startDate;
          const formatStartDate = data?.criteria?.startDate;
          const formatEndDate = data?.criteria?.endDate;
          let formattedStartDate = "";
          let formattedEndDate = "";

          if (formatStartDate) {
            try {
              const parsedDate = parseISO(formatStartDate);
              formattedStartDate = format(parsedDate, "dd MMM yyyy");
            } catch (error) { }
          } else {
            formattedEndDate = "";
          }
          if (formatEndDate) {
            try {
              const parsedDate = parseISO(formatEndDate);
              formattedEndDate = format(parsedDate, "dd MMM yyyy");
            } catch (error) { }
          } else {
            formattedEndDate = "";
          }
          return (
            <span style={{ display: "flex", marginLeft: "-12px" }}>
              {formattedStartDate} {formatStartDate && "-"} {formattedEndDate}
            </span>
          );
        },
      },

      // {
      //   name: "offerType",
      //   header: "Offer Type",
      //   visible: true,
      //   type: "string",
      //   filtering: true,
      //   minWidth: 170,
      //   defaultFlex: 1,
      //   textAlign: "start",
      //   sortable: false,
      //   render: ({ data }) => {
      //     const discountType = data?.discount?.type;
      //     const formattedDiscountType = addSpacesBeforeCaps(discountType);
      //     return (
      //       <span style={{ display: "flex", marginLeft: "-12px" }}>
      //         {formattedDiscountType}
      //       </span>
      //     );
      //   },
      // },

      {
        name: "status",
        header: "Status",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 140,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => {
          let backgroundColor;
          let color;
          let value;
          const status = data?.status;
          if (status === "ACTIVE") {
            backgroundColor = "#D5FBD2";
            color = "#0B6A48";
            value = "Active";
          } else if (status === "INACTIVE") {
            backgroundColor = "#FDE3D6";
            color = "#B9232F";
            value = "Inactive";
          } else {
            backgroundColor = "#FBEFCB";
            color = "#9E5707";
            value = "Default";
          }
          return (
            <span
              style={{
                marginLeft: "-20px",
                paddingBottom: "6px",
                paddingRight: "8px",
                paddingLeft: "8px",
                paddingTop: "5px",
                borderRadius: "8px",
                backgroundColor,
                color,
                textTransform: "uppercase",
              }}
            >
              {value}
            </span>
          );
        },
      },
      {
        name: "id",
        header: "Actions",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 100,
        defaultFlex: 1,
        textAlign: "center",
        sortable: false,
        render: ({ data }) => {
          let items = [];
          items.push({
            id: "EDIT",
            label: (
              <Link to={`/offerManagement/editEmiOffer`}>
                <div style={{ display: "flex", gap: "4px" }}>
                  <Typography>Edit Offer</Typography>
                </div>
              </Link>
            ),
            value: {
              type: "edit",
              data: data,
            },
            enable: true,
          });

          if (data?.enabled === true) {
            items.push({
              id: "DISABLE",
              label: (
                <div style={{ display: "flex", gap: "4px" }}>
                  <Typography>Disable Offer</Typography>
                </div>
              ),
              value: {
                data: data,
                type: "disable",
              },
              enable: true,
            });
          }

          if (data?.enabled === false) {
            items.push({
              id: "ENABLE",
              label: (
                <div style={{ display: "flex", gap: "4px" }}>
                  <Typography>Enable Offer</Typography>
                </div>
              ),
              value: {
                data: data,
                type: "enable",
              },
              enable: true,
            });
          }

          items.push({
            id: "DELETE",
            label: (
              <div style={{ display: "flex", gap: "4px" }}>
                <Typography>Delete Offer</Typography>
              </div>
            ),
            value: {
              // token: data?.token,
              type: "delete",
              data: data,
            },
            enable: true,
          });

          return (
            items?.length > 0 && (
              <MoreOptionsPopOver
                items={items}
                handleActionSelect={handleActionSelect}
              />
            )
          );
        },
      },
    ],
  };

  return schema;
}
